const state = {
    pages:[],
};

const getters = {
    getPages: state => state.pages,
};

const actions = {
    setPages: (store, payload) => store.commit("PAGES_SET",payload),
};

const mutations = {
    PAGES_SET: (state, payload) => state.pages = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};